module.exports = __webpack_public_path__ + "static/terminal--gold_moon.80c20d1fb97cd0acec40f063ff0dca5f.jpg";